import { SVGProps } from 'react'

const SvgSensorEventGenericDeviceIssue = (props: SVGProps<SVGSVGElement>) => (
  <svg fill='none' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M12 2a1 1 0 0 0-1 1v1H8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3v5a1 1 0 1 0 2 0v-5h3a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-3V3a1 1 0 0 0-1-1zm0 4.75c.168 0 .337.083.434.25l3.03 5.25a.5.5 0 0 1-.433.75H8.97a.5.5 0 0 1-.434-.75L11.566 7A.496.496 0 0 1 12 6.75zm0 1.5a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 1 0v-1.5a.5.5 0 0 0-.5-.5zm-.025 3a.501.501 0 1 0 .025 0h-.025z' />
  </svg>
)

export default SvgSensorEventGenericDeviceIssue
